import { Card } from "antd";
import React from "react";
import { Column } from "@ant-design/plots";
import { useSelector } from "react-redux";
import { flatMap } from "lodash";

const ProjectsActualExpenditureGraph = () => {
  const { projectsGraphData } = useSelector((state) => state.projectsState);

  const data = flatMap(
    projectsGraphData?.projectsActualExpenditureGraphData,
    (project) => {
      return [
        {
          name: "Approved Budget",
          "Approved Budget": parseInt(project.approvedBudget),
          projectName: project.project,
        },
        {
          name: "Actual Expenditure",
          "Approved Budget": project.totalActualExpenditure,
          projectName: project.project,
        },
        {
          name: "Variance",
          "Approved Budget": project.variance,
          projectName: project.project,
        },
      ];
    }
  );

  console.log(data);
  const config = {
    data,
    xField: "projectName",
    yField: "Approved Budget",
    colorField: "name",
    group: {
      padding: 0,
    },
  };

  return (
    <Card title="Budget Performance">
      <Column {...config} />
    </Card>
  );
};

export default ProjectsActualExpenditureGraph;
